"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const financialBankAccountSlice_1 = require("../profile/financialBankAccount.tsx/financialBankAccountSlice");
const multiDocumentManager_1 = __importStar(require("../../components/documentUpload/multiDocumentManager"));
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const store_1 = require("../../store");
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const UploadBankStatement = () => {
    const navigation = (0, useAppNavigation_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const bankAccounts = (0, store_1.useAppSelector)((state) => state.home.financial_data ? state.home.financial_data.bank_accounts : []);
    const [documents, setDocuments] = (0, react_1.useState)([]);
    if (bankAccounts && bankAccounts.length > 0) {
        const primaryBankAccount = bankAccounts.find((bankAccount) => bankAccount.is_primary);
        if (primaryBankAccount) {
            setDocuments(primaryBankAccount.bank_statements);
            return (react_1.default.createElement(navContainer_1.default, { isLoading: false, childrenTitle: "Manual Bank Statements Upload", footer: react_1.default.createElement(primaryButton_1.default, { title: "SAVE", onPress: () => navigation.navigate(screenConstants_1.HOME_SCREEN), disabled: false, eventName: "validate_bank_statements" }) },
                react_1.default.createElement(multiDocumentManager_1.default, { documents: documents, setDocuments: setDocuments, mimeType: ['application/pdf'], requirements: ['12 MONTHS OF BANK STATEMENT'], screenName: "manualStatement", askPassword: true, uploadTo: multiDocumentManager_1.submitStatement, deleteDocument: financialBankAccountSlice_1.deleteStatement, bankAccountId: primaryBankAccount.bank_id, label: "Bank statements" })));
        }
    }
    return (
    // TODO ADD ERROR MESSAGE IF NO PRIMARY BANK ACCOUNT OR BANK ACCOUNTS
    // nosemgrep  - should match format 'MODULE.FEATURE.*'
    react_1.default.createElement(react_native_1.View, null, t('uploadBankStatement.error')));
};
exports.default = UploadBankStatement;
